import { SkeletonCard } from '@/components/SkeletonCard'
import { UnitCard } from '@/components/UnitCard'
import { PlanCard } from '@/components/PlanCard'
import { CommunityCard } from '@/components/CommunityCard'
import { CardGrid } from '@/components/CardGrid'

const FPO_IMAGE = '/wp-content/plugins/ecs-spaces/public/images/spaces-fpo.png'

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

function UnitSkeletons () {
	return (
		<Section title='Unit (skeleton → loaded)'>
			<CardGrid columns={4}>
				<SkeletonCard variant='unit' hasPricingAction />
				<UnitCard
					unitNumber='1201-A'
					floorPlanName='The Alpine'
					imageUrl={FPO_IMAGE}
					beds='2 Bed'
					baths='2 Bath'
					sqft={1145}
					availableDate='Nov 12'
					priceRange='$2,265'
					baseRent='$2,130'
					leaseTerm='12 Mo.'
					onPricingClick={() => { /* Only needs to render the calculator button. */ }}
				/>
				<SkeletonCard variant='unit' />
				<UnitCard
					unitNumber='1202-B'
					floorPlanName='The Birch'
					imageUrl={FPO_IMAGE}
					beds='1 Bed'
					baths='1 Bath'
					sqft={750}
					availableDate='Now'
					priceRange='$1,845'
					baseRent='$1,650'
					leaseTerm='12 Mo.'
				/>
			</CardGrid>
		</Section>
	)
}

function PlanSkeletons () {
	return (
		<Section title='Plan (skeleton → loaded)'>
			<CardGrid columns={4}>
				<SkeletonCard variant='plan' />
				<PlanCard
					planName='The Alpine'
					imageUrl={FPO_IMAGE}
					beds='2 Bed'
					baths='2 Bath'
					sqftRange='1,050 – 1,145'
					matchingUnits={6}
					totalPrice='$2,265'
					baseRent='$2,130'
					leaseTerm='12 Mo.'
				/>
			</CardGrid>
		</Section>
	)
}

function CommunitySkeletons () {
	return (
		<Section title='Community (skeleton → loaded)'>
			<CardGrid columns={4}>
				<SkeletonCard variant='community' />
				<CommunityCard
					name='Milo (Garden)'
					imageUrl={FPO_IMAGE}
					phone='(303) 555-0100'
					phoneHref='tel:3035550100'
					matchingUnits={12}
					totalPrice='$1,845'
					baseRent='$1,650'
					leaseTerm='12 Mo.'
					hasFees
					hasDisclaimerSymbol
				/>
			</CardGrid>
		</Section>
	)
}

/** Each skeleton beside the card it stands in for, to compare footprint and height. */
export function SkeletonCardSandbox () {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			<UnitSkeletons />
			<PlanSkeletons />
			<CommunitySkeletons />
		</div>
	)
}
